/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type samlKeyOrOrg =
    | {
          key?: samlKeyOrOrg.key
      }
    | {
          org?: number
      }

export namespace samlKeyOrOrg {
    export enum key {
        HELM = 'helm'
    }
}
